window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('.ce-video .video-plyr').length) {
    import('./_plyr.js').then((module) => {
      module.Init();
    });
  }
});

export default {};
